<template>
  <div class="animated fadeIn">
    <Row>
      <Input search @on-search="onFilterClick" size="small" clearable v-model="keywordFilter" placeholder="设备名称"
             style="width: 200px; margin-right: 3px;"></Input>
      <Button size="small" type="primary" style="margin-right: 3px;" @click="onFilterClick">查询</Button>
      <Button size="small" type="primary" style="margin-right: 3px;" @click="addPositioningDeviceTypeModal=true">
        添加定位设备类型
      </Button>
    </Row>
    <Row style="margin-top: 3px;">
      <div style="width: 100%;">
        <div style="position:relative;">
          <context-menu ref="contextMenuRef" :menuList="menuList" @callback="onContextMenuCallback"></context-menu>
          <Table border highlight-row size="small" height="600" :columns="columns" :stripe="true" :data="content"
                 ref="table" :height="tableHeight"
                 @on-sort-change="sortChange" @on-filter-change="filterChange"
                 @contextmenu.prevent.native="onTableRightClick($event)"></Table>
          <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="listLoadding">
            <Spin size="large"></Spin>
            <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
          </div>
        </div>
        <Page size="small" :total="totalElements" :page-size="pageSize" :current="pageIndex" :show-total="true"
              show-elevator
              @on-change="setPage"
              show-sizer @on-page-size-change="refreshPage" :page-size-opts="pagesizeopts"
              style="text-align:right;margin-top:3px;"></Page>

      </div>
    </Row>
    <!--  添加设备类型图片组件  -->
    <positioning-device-type-picture-modal v-model="positioningDeviceTypePictureModal"
                                           :initValue="positioningDeviceTypePictureModalId"></positioning-device-type-picture-modal>
    <!--  添加设备类型组件  -->
    <add-positioning-device-type-modal v-model="addPositioningDeviceTypeModal"
                                       @on-success="onSuccess"></add-positioning-device-type-modal>
    <!--  修改设备类型组件  -->
    <modif-positioning-device-type-modal v-model="modifPositioningDeviceTypeModal"
                                         :initValue="modifPositioningDeviceTypeModalId"
                                         @on-success="refreshPage"></modif-positioning-device-type-modal>
    <!--  设备类型备注组件  -->
    <positioning-device-type-add-processremark-modal v-model="positioningDeviceTypeAddProcessremarkModal"
                                                     :initValue="positioningDeviceTypeAddProcessremarkId"
                                                     @on-success="refreshPage"></positioning-device-type-add-processremark-modal>
    <!--  表格右击设置组件  -->
    <web-table-columns-modal :columnList.sync="columns" :tableName="$options.name"
                             v-model="webTableColumnsModal"></web-table-columns-modal>
  </div>
</template>

<script>
  import PositioningDeviceTypePictureModal from '@/view/im/components/positioning-device-type-picture-modal'
  import AddPositioningDeviceTypeModal from '@/view/im/components/add-positioning-device-type-modal'
  import ModifPositioningDeviceTypeModal from '@/view/im/components/modif-positioning-device-type-modal'
  import PositioningDeviceTypeAddProcessremarkModal
    from '@/view/im/components/positioning-device-type-add-processremark-modal'

  import Vue from 'vue'
  import store from '@/store'
  import {mapActions} from 'vuex'
  import {genQueryParam, genSortParam} from '@/libs/queryparamhelper'

  export default {
    name: 'positioningdevicetype',
    components: {
      PositioningDeviceTypePictureModal,
      AddPositioningDeviceTypeModal,
      ModifPositioningDeviceTypeModal,
      PositioningDeviceTypeAddProcessremarkModal
    },
    data() {
      return {
        // 添加设备类型图片组件
        positioningDeviceTypePictureModal: false,
        positioningDeviceTypePictureModalId: null,
        // 添加定位设备类型组件
        addPositioningDeviceTypeModal: false,
        // 修改定位设备类型组件
        modifPositioningDeviceTypeModal: false,
        modifPositioningDeviceTypeModalId: null,
        // 追加备注
        positioningDeviceTypeAddProcessremarkModal: false,
        positioningDeviceTypeAddProcessremarkId: null,

        // 关键字搜索
        keywordFilter: null,
        // 根据生产商筛选
        manufacturerFilter: null,
        // 表格及分页样式
        pageFilter: 30,
        pagesizeopts:[30, 50,100,200],
        tableHeight: 160,
        pageIndex: 1,
        sort: null,
        listLoadding: false,

        //  右击设置表格
        webTableColumnsModal: false,
        menuList: [
          {title: '设置表格列', content: {}}
        ],

        // table表头
        columns: [
          {
            title: 'ID',
            resizable: true,
            key: 'id',
            sortable: 'custom',
            tooltip: 'true',
            width: 100
          },
          {
            title: '定位设备型号',
            resizable: true,
            key: 'name',
            ellipsis: 'true',
            width: 180
          },
          {
            title: '定位设备生产商型号',
            resizable: true,
            key: 'manufacturername',
            ellipsis: 'true',
            width: 180
          },
          {
            title: '设备生产商',
            resizable: true,
            key: 'manufacturer',
            ellipsis: 'true',
            width: 180,
            filters: [
              {label: '惠州博实结科技有限公司', value: '惠州博实结科技有限公司'},
              {label: '杭州海康汽车技术有限公司', value: '杭州海康汽车技术有限公司'},
              {label: '深圳市锐明技术股份有限公司', value: '深圳市锐明技术股份有限公司'},
              {label: '有为', value: '有为'}
            ],
            filterMultiple: true,
            filterRemote: (val) => {
              if (val && val.length > 0) {
                this.manufacturerFilter = []
                val.forEach(item => {
                  this.manufacturerFilter.push(genQueryParam('manufacturer', 'EQ', item))
                })
              } else {
                this.manufacturerFilter = null
              }
              this.setPage(1)
            }
          },
          {
            title: '是否ADAS',
            resizable: true,
            key: 'isadas',
            ellipsis: 'true',
            tooltip: 'true',
            width: 180,
            render: function (h, params) {
              if (params.row.adas) {
                return h('div', '是')
              } else {
                return h('div', '否')
              }
            }
          },
          {
            title: '设备费用模式',
            resizable: true,
            key: 'isfree',
            ellipsis: 'true',
            tooltip: 'true',
            width: 180,
            render: function (h, params) {
              if (params.row.isfree != null) {
                if (params.row.isfree == 1) {
                  return h('div', '自费')
                } else if (params.row.isfree == 2) {
                  return h('div', '普通免费模式')
                } else {
                  return h('div', '太好保免费模式')
                }
              } else {
                return h('div', '无')
              }
            }
          },
          {
            title: '设备参数',
            resizable: true,
            key: 'parameter',
            ellipsis: 'true',
            tooltip: 'true',
            width: 180
          },
          // {
          //   title: '设备型号',
          //   resizable: true,
          //   key: 'positioningDeviceModel',
          //   ellipsis: 'true',
          //   width: 180,
          //   filters: [
          //     { label: 'BSJ-A6-BD', value: 1 },
          //     { label: 'BSJ-GF03', value: 2 },
          //     { label: 'BSJ-M11', value: 3 },
          //     { label: 'BSJ-A6L', value: 13 },
          //     { label: 'BSJ-A7', value: 14 },
          //     { label: 'K5', value: 4 },
          //     { label: 'D5X', value: 5 },
          //     { label: 'G-3G', value: 6 },
          //     { label: 'D5X-HDD', value: 7 },
          //     { label: 'D5X-XR', value: 8 },
          //     { label: 'BSJ-GF06', value: 9 },
          //     { label: 'BSJ-RM01', value: 10 },
          //     { label: 'HIK-A3', value: 11 },
          //     { label: 'HIK-A3L', value: 12 }
          //   ],
          //   filterMultiple: false,
          //   filterRemote: (val) => {
          //     if (val.length > 0) {
          //       this.positioningDeviceModelFilter = genQueryParam('positioningDeviceModel', 'EQ', val[0])
          //     } else {
          //       this.positioningDeviceModelFilter = null
          //     }
          //   },
          //   render: function (h, params) {
          //     let positioningDeviceModel = params.row.positioningDeviceModel
          //     if (positioningDeviceModel === 1) {
          //       return h('div', 'BSJ-A6-BD')
          //     } else if (positioningDeviceModel === 2) {
          //       return h('div', 'BSJ-GF03')
          //     } else if (positioningDeviceModel === 3) {
          //       return h('div', 'BSJ-M11')
          //     } else if (positioningDeviceModel === 13) {
          //       return h('div', 'BSJ-A6L')
          //     } else if (positioningDeviceModel === 14) {
          //       return h('div', 'BSJ-A7')
          //     } else if (positioningDeviceModel === 4) {
          //       return h('div', 'K5')
          //     } else if (positioningDeviceModel === 5) {
          //       return h('div', 'D5X')
          //     } else if (positioningDeviceModel === 6) {
          //       return h('div', 'G-3G')
          //     } else if (positioningDeviceModel === 7) {
          //       return h('div', 'D5X-HDD')
          //     } else if (positioningDeviceModel === 8) {
          //       return h('div', 'D5X-XR')
          //     } else if (positioningDeviceModel === 9) {
          //       return h('div', 'BSJ-GF06')
          //     } else if (positioningDeviceModel === 10) {
          //       return h('div', 'BSJ-RM01')
          //     } else if (positioningDeviceModel === 11) {
          //       return h('div', 'HIK-A3')
          //     } else if (positioningDeviceModel === 12) {
          //       return h('div', 'HIK-A3L')
          //     } else {
          //       return h('div', '未知')
          //     }
          //   }
          // },

          {
            title: '更新时间',
            resizable: true,
            sortable: 'custom',
            ellipsis: 'true',
            tooltip: 'true',
            key: 'updateDatetime',
            width: 180,
            render: function (h, params) {
              if (params.row.updateDatetime) {
                let d = new Date(params.row.updateDatetime)
                return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
              }
            }
          },
          {
            title: '创建时间',
            resizable: true,
            sortable: 'custom',
            ellipsis: 'true',
            tooltip: 'true',
            key: 'createDatetime',
            width: 180,
            render: function (h, params) {
              if (params.row.createDatetime) {
                let d = new Date(params.row.createDatetime)
                return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
              }
            }
          },
          {
            title: '备注',
            resizable: true,
            key: 'remark',
            ellipsis: 'true',
            tooltip: 'true',
            minWidth: 100
          },
          {
            title: '操作',
            resizable: true,
            key: 'action',
            align: 'left',
            ellipsis: 'true',
            minWidth: 180,
            maxWidth: 250,
            fixed: 'right',
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: false
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.positioningDeviceTypePictureModalId = params.row.id
                      this.positioningDeviceTypePictureModal = true
                    }
                  }
                }, '设备图片'),
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: false
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.modifPositioningDeviceTypeModalId = params.row.id
                      this.modifPositioningDeviceTypeModal = true
                    }
                  }
                }, '修改'),
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: false
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.positioningDeviceTypeAddProcessremarkId = params.row.id
                      this.positioningDeviceTypeAddProcessremarkModal = true
                    }
                  }
                }, '追加备注'),
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: false
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: '删除设备类型',
                        content: '<p>是否确认删除此设备类型</p>',
                        onOk: () => {
                          store.dispatch('PositioningDeviceTypeServ_DeleteObj', {params: {id: params.row.id}}).then(() => {
                            this.$Message.success('删除成功')
                            this.refreshPage()
                          }).catch(err => {
                            this.$Message.error(err)
                          })
                        },
                        onCancel: () => {
                        }
                      })
                    }
                  }
                }, '删除')
              ])
            }
          }
        ]// cloumn
      }
    },
    methods: {
      onFilterClick() {
        this.setPage(1)
      },
      // 表格排序
      sortChange({column, key, order}) {
        this.sort = {
          name: key,
          asc: order === 'asc'
        }
        this.refreshPage()
      },
      filterChange() {
        this.refreshPage()
      },
      // 刷新当前页
      refreshPage(value) {
        this.pageFilter = value
        this.setPage(this.pageIndex)
      },
      onSuccess() {
        this.setPage(1)
      },
      setPage(page) {
        console.log('setPage' + page)
        this.pageIndex = page
        this.listLoadding = true

        let qo1 = null
        let queryParams = []
        let sortParam = null

        if (this.sort) {
          sortParam = genSortParam(this.sort.name, this.sort.asc)
        }

        if (this.manufacturerFilter) {
          qo1 = this.manufacturerFilter
        }

        store.dispatch('PositioningDeviceTypeServ_GetPage', {
          params: null,
          urlparams: {
            q: queryParams,
            qo1: qo1,
            ps: this.pageFilter,
            p: page,
            keyword: this.keywordFilter,
            sort: sortParam
          }
        }).then(() => {
          this.listLoadding = false
        }).catch(err => {
          this.listLoadding = false
          this.$Message.error(err)
        })
      },
      /**
       * 右键菜单点击回调
       */
      onContextMenuCallback(item) {
        if (item.title === '设置表格列') {
          this.webTableColumnsModal = true
        }
      }
    },
    /**
     * 表格右键回调
     */
    onTableRightClick(e) {
      this.$refs.contextMenuRef.showMenu(e, this.$el, 0, -20)
    },
    computed: {
      totalElements() {
        if (store.getters.get_PositioningDeviceType_GetPageResult) {
          return store.getters.get_PositioningDeviceType_GetPageResult.totalElements
        } else {
          return 0
        }
      },
      content() {
        if (store.getters.get_PositioningDeviceType_GetPageResult) {
          return store.getters.get_PositioningDeviceType_GetPageResult.content
        } else {
          return []
        }
      },
      pageSize() {
        if (store.getters.get_PositioningDeviceType_GetPageResult) {
          return store.getters.get_PositioningDeviceType_GetPageResult.size
        } else {
          return 0
        }
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
        window.onresize = () => {
          this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
        }
        this.setPage(1)
      })
    }
  }
</script>

<style scoped>

</style>
